export const textsByLanguage = {
  en: {
    title: 'In preparation',
    message: `Your Tracking Page is being prepared. Please come back in about an hour.
    If no Tracking Page is shown - get in touch with us.`,
  },
  de: {
    title: 'In Vorbereitung',
    message: `Ihre Tracking-Seite wird vorbereitet. Bitte kommen Sie in ungefähr einer Stunde zurück.
    Wenn keine Tracking-Seite angezeigt wird, setzen Sie sich mit uns in Verbindung.`,
  },
  fr: {
    title: 'En préparation',
    message: `Votre page de suivi est en cours de préparation. Veuillez revenir dans environ une heure.
    Si aucune page de suivi n\'est affichée, contactez-nous.`,
  },
  it: {
    title: 'In preparazione',
    message: `La tua pagina di monitoraggio è in preparazione. Per favore torna tra circa un\'ora.
    Se non viene visualizzata alcuna pagina di monitoraggio, mettiti in contatto con noi.`,
  },
  nl: {
    title: 'In voorbereiding',
    message: `Uw trackingpagina wordt voorbereid. Kom alsjeblieft over een uur terug.
    Neem contact met ons op als er geen trackingpagina wordt weergegeven.`,
  },
  pl: {
    title: 'W przygotowaniu',
    message: `Twoja strona śledzenia jest przygotowywana. Wróć za około godzinę.
    Jeśli strona śledzenia nie jest wyświetlana - skontaktuj się z nami.`,
  },
  cs: {
    title: 'Připravuje se',
    message: `Vaše sledovací stránka se připravuje. Vraťte se asi za hodinu.
    Pokud se nezobrazí žádná stránka pro sledování - kontaktujte nás.`,
  },
  sk: {
    title: 'V príprave',
    message: `Vaša sledovacia stránka sa pripravuje. Vráťte sa asi o hodinu.
    Ak sa nezobrazí žiadna stránka na sledovanie - kontaktujte nás.`,
  },
  da: {
    title: 'Under forberedelse',
    message: `Din sporingsside er under forberedelse. Kom tilbage om cirka en time.
    Hvis der ikke vises nogen sporingsside - kontakt os.`,
  },
  fi: {
    title: 'Valmisteilla',
    message: `Seurantasivua valmistellaan. Palaa takaisin noin tunnin kuluttua.
    Jos seurantasivua ei näy, ota meihin yhteyttä.`,
  },
  no: {
    title: 'Under forberedelse',
    message: `Sporingssiden din blir forberedt. Kom tilbake om en time.
    Hvis det ikke vises noen sporingsside - ta kontakt med oss.`,
  },
  sv: {
    title: 'I förberedelse',
    message: `Din spårningssida förbereds. Kom tillbaka om ungefär en timme.
    Om ingen spårningssida visas - kontakta oss.`,
  },
  es: {
    title: 'En preparación',
    message: `Se está preparando su página de seguimiento. Vuelva en aproximadamente una hora.
    Si no se muestra una página de seguimiento, póngase en contacto con nosotros.`,
  },
  pt: {
    title: 'Em preparação',
    message: `Sua página de rastreamento está sendo preparada. Volte em cerca de uma hora.
    Se nenhuma página de rastreamento for exibida - entre em contato conosco.`,
  },
  ro: {
    title: 'In pregatire',
    message: `Pagina dvs. de urmărire este în curs de pregătire. Vă rog să vă întoarceți în aproximativ o oră.
    Dacă nu este afișată nicio pagină de urmărire - contactați-ne.`,
  },
  hu: {
    title: 'Előkészületben',
    message: `A nyomkövetési oldal előkészítés alatt áll. Kérem, jöjjön vissza egy óra múlva.
    Ha nem jelenik meg nyomkövető oldal, kérjük, lépjen kapcsolatba velünk.`,
  },
};

export const fallbackInfo = {
  title: 'We lost track',
  message: 'The page you are looking for is currently unavailable. Please come back later.',
};

export const notFoundInfo = {
  title: 'Tracking Page Not Found',
  // eslint-disable-next-line quotes
  message:
    'Your Tracking Page couldn\'t be found. Please try again later. If the problem persists, please get in touch.',
};

export const errorTypes = {
  notFound: 'not-found',
  noInfo: 'no-info',
};

export function getTranslatedInfo(errorType, language) {
  if (errorType === errorTypes.notFound) return notFoundInfo;

  if (errorType === errorTypes.noInfo) {
    return textsByLanguage[language] || textsByLanguage.en;
  }

  return fallbackInfo;
}
